/**
 * WhatsApp Broadcast Subscription Page
 *
 * - Argentina (AR): redirect directo a MercadoPago (sin email)
 * - Internacional: Stripe Embedded Checkout "Miembro Basic"
 */

import WhatsAppBroadcastTemplate from "@/components/templates/WhatsAppBroadcastTemplate";

export default function WhatsAppBroadcast() {
  return <WhatsAppBroadcastTemplate />;
}
